<template lang="pug">
fieldset(:disabled="loading")
  form(@submit.prevent="save")
    modal(active title="Configurar desconto" @close="$router.back()")
      div(slot="modal-body")
        p
          | Os usuários que forem vinculados ao afiliado pagarão ao assinar o plano
          span #[b  {{ plan.title }}] o valor dele com o desconto informado.
        .divider
        form-group(:validation="$v.form" field="filiation" label="Afiliado")
          filiation-picker(:disabled="Boolean(integrationPlan)" v-model="$v.form.filiation.$model")
        .columns.align-center
          .column.col-4
            form-group(:validation="$v.form" field="discountValue" label="Valor do desconto")
              masked-money.form-input(
                v-model="$v.form.discountValue.$model"
                :disabled="!form.discountType"
                v-bind="moneyAttrs"
              )
          .column.mt-2.pt-2
            .form-group.mt-2
              label.form-radio.form-inline
                input(type="radio" value="percent" v-model="$v.form.discountType.$model")
                i.form-icon
                | Em percentual
              label.form-radio.form-inline
                input(type="radio" value="fixed" v-model="$v.form.discountType.$model")
                i.form-icon
                | Valor fixo
        .divider        
        .form-group.mt-2
          label.form-switch.form-inline
            input(type="checkbox" v-model="$v.form.active.$model")
            i.form-icon
            | Ativo
      div(slot="modal-footer")
        .divider
        a.btn.btn-link.mr-2(@click="$router.back()")
          | Cancelar
        button.btn.btn-primary(:disabled="$v.form.$invalid" :class="{loading}")
          i.fas.fa-check
          |  Salvar
</template>

<script>
import integrationPlans from '@/services/integrationPlans'
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    plan: { type: Object, required: true },
    fetchData: { type: Function, required: true },
    integrationPlan: { type: Object, default: null },
  },
  data() {
    return {
      form: {
        discountType: null,
        discountValue: null,
        filiation: null,
        active: true,
      },
      loading: false,
    }
  },
  computed: {
    moneyAttrs() {
      if (this.form.discountType === 'percent') return { suffix: ' %' }
      if (this.form.discountType === 'fixed') return { prefix: 'R$ ' }
      return {}
    },
  },
  methods: {
    async create() {
      try {
        this.loading = true
        await integrationPlans.create(this.plan.id, this.form)
        this.$toaster.success('Desconto criado')
        this.$router.back()
        this.fetchData()
      } catch (e) {
        this.$toaster.error(e.message)
      } finally {
        this.loading = false
      }
    },
    async update() {
      try {
        this.loading = true
        await integrationPlans.update(
          this.plan.id,
          this.integrationPlan.id,
          this.form,
        )
        this.$toaster.success('Desconto alterado')
        this.$router.back()
        this.fetchData()
      } catch (e) {
        this.$toaster.error(e.message)
      } finally {
        this.loading = false
      }
    },
    save() {
      if (this.integrationPlan) this.update()
      else this.create()
    },
  },
  validations: {
    form: {
      filiation: { required },
      discountType: { required },
      discountValue: { required },
      active: {},
    },
  },
  created() {
    if (this.integrationPlan) {
      this.form.filiation = this.integrationPlan.filiation
      this.form.discountType = this.integrationPlan.discountType
      this.form.discountValue = this.integrationPlan.discountValue
      this.form.active = this.integrationPlan.active
    }
  },
}
</script>
